module.exports = __webpack_public_path__ + "static/media/resocial.5b8c52e9.jpg";